<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <el-select
              class="select-default mb-3"
              style="width: 100%"
              multiple
              filterable
              placeholder="Municipios"
              collapse-tags
              v-model="filter_municipalities">
              <el-option
                class="select-default"
                v-for="item in municipalities"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <el-date-picker
              style="width: 100%"
              :clearable="false"
              v-model="rangeDate"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="-"
              start-placeholder="Fecha Inicial"
              end-placeholder="Fecha Final"
              align="center">
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-4 text-center">
              <br class="c-none">
              <button type="button" class="btn btn-warning" @click="getFilteredData">Filtrar Datos</button>
          </div>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div v-if="canIndex()" class="text item">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-6">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-4" style="width: 100%">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('disponibilidad', 'Disponibilidad', 'a3', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('disponibilidad', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('disponibilidad', tableData, tableColumns)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-2">
                <br class="c-none">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      border>
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
      <div class="row">
        <div class="col-4">
          <div class="text-right">
            <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportPDF('disponibilidad', 'Disponibilidad', 'a3', tableData, tableColumns)"><i class="fa fa-file-pdf-o"></i>
                Exportar a PDF
            </button>
          </div>
        </div>
        <div class="col-4">
          <div class="text-center">
            <button oncli class="btn btn-success btn-fg custom-shadow-btn" @click="exportExcel('disponibilidad', tableData, tableColumns)"><i class="fa fa-file-excel-o"></i>
            Exportar a Excel
          </button>
          </div>
        </div>
        <div class="col-4">
          <div class="text-left">
            <button class="btn btn-info btn-fg custom-shadow-btn" @click="exportCSV('disponibilidad', tableData, tableColumns)"><i class="fa fa-file-text-o"></i>
              Exportar a CSV
            </button>
          </div>
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="col-md-12">
          <card class="custom-shadow-card-header">
            <span v-if="Object.keys(chartOptions1).length > 0">
              <div class="row">
                <div class="col-12">
                  <highcharts :options="chartOptions1"></highcharts>
                </div>
              </div>
            </span>
            <div slot="footer" class="text-left">
              <p class="card-category"><i class="fa fa-clock-o"></i> Ultimo actualización {{currentTime}}</p>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <card class="custom-shadow-card-header">
            <span v-if="Object.keys(chartOptions2).length > 0">
              <div class="row">
                <div class="col-12">
                  <highcharts :options="chartOptions2"></highcharts>
                </div>
              </div>
            </span>
            <div slot="footer" class="text-left">
              <p class="card-category"><i class="fa fa-clock-o"></i> Ultimo actualización {{currentTime}}</p>
            </div>
          </card>
        </div>
      </div>
      <br/>
    </div>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import MixinDatePicker from "src/util/mixinDatePicker"
  import mixinCharts from "src/util/mixinCharts"
  import table from './availabilityTable'
  import moment from 'moment'
  import {Chart} from 'highcharts-vue'
  import Highcharts from 'highcharts'
  import exportingInit from 'highcharts/modules/exporting'
  import {StatsCard} from 'src/components/index'

  exportingInit(Highcharts)

  export default {
    components: {
      StatsCard,
      highcharts: Chart
    },

    data () {
      return {
        municipalities: [],
        isShow: true,
        tableColumns: table,
        currentTime: moment().format('hh:mm:ss'),
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        chartOptions1: {},
        chartOptions2: {},
        rangeDate: [new Date((new Date().getFullYear()), 0, 1), new Date((new Date().getFullYear()), 11 + 1, 0)],
      }
    },
    mixins: [mixinMasters, mixinPermissions, MixinDatePicker, mixinCharts],
    methods: {
      getFilteredData() {
        let self = this
        this.$emit('cotentLoading', true)

        let data = {}
        data.route ='availability'

        data.init_date = moment(this.rangeDate[0]).format('YYYY-MM-DD')
        data.end_date = moment(this.rangeDate[1]).format('YYYY-MM-DD')
        data.filter_municipalities = (this.filter_municipalities.length == 0) ? '' : this.filter_municipalities.join()

        this.saveMaster(data).then((response) => {
          self.tableData = response.data.availability
          self.municipalities = response.data.municipalities
          self.chartOptions1 = self.columns(response.data.chart1, null)
          self.chartOptions2 = self.columns(response.data.chart2, null)
          self.searchFuse(this.tableColumns.map(prop => { return prop.prop }))
          self.$emit('cotentLoading', false)

        }).catch((error) => {
          self.showMessageErrors(error)
          self.$emit('cotentLoading', false)
        })
      },
    },
    created(){
      if(this.canIndex()) {
        this.getFilteredData()
      }
    }
  }
</script>
